
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 18 18"}},[_c('defs',[_c('path',{attrs:{"id":"plus_svg__a","d":"M10.062 10.061l-6.08-5.998 6.08 5.998 6.202-5.998-6.202 5.998zm0 0l5.957 5.877-5.957-5.877-6.076 5.877 6.076-5.877z"}})]),_c('use',{attrs:{"fill":"#062521","fill-rule":"evenodd","stroke":"#062521","stroke-linecap":"round","transform":"rotate(-45 8.293 10.707)","xlink:href":"#plus_svg__a"}})])
      }
    
      }
    